export class AuthenticationService {
  
  getUserToken(): string | null {
    return localStorage.getItem('token');
  }

  clearUserToken(): void {
    localStorage.removeItem('token');
  } 
}
